import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import GlgInlineLoadingSpinner from '../../../../shared/components/glg_loading_spinner_inline'
import { useGetGenericWhsCoursesQuery } from '../../../api/courses'

// Fetches options for a single level given parent-level selections
const LevelSelect = ({ level, levelIndex, levelSelections, levels, onSelect }) => {
  const params = { level }
  levels.slice(0, levelIndex).forEach((lvl) => {
    if (levelSelections[lvl]) {
      params[`${lvl}_id`] = levelSelections[lvl]
    }
  })

  const parentSelected = levelIndex === 0 || !!levelSelections[levels[levelIndex - 1]]

  const { data: courseList, isLoading } = useGetGenericWhsCoursesQuery(params, {
    skip: !parentSelected,
  })

  const options = courseList && typeof courseList === 'object'
    ? Object.entries(courseList).map(([id, name]) => ({ value: id, label: name }))
    : []

  if (!parentSelected) return null

  return (
    <div className="add-margin-top-10">
      {isLoading ? (
        <GlgInlineLoadingSpinner show={true} />
      ) : (
        <select
          className="form-control"
          value={levelSelections[level] || ''}
          onChange={(e) => onSelect(level, e.target.value, options.find((o) => o.value === e.target.value)?.label || '')}
        >
          <option value="" disabled>{window.I18n.t('generic_whs.courses.popup.select_level', { level })}</option>
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      )}
    </div>
  )
}

LevelSelect.propTypes = {
  level: PropTypes.string.isRequired,
  levelIndex: PropTypes.number.isRequired,
  levelSelections: PropTypes.object.isRequired,
  levels: PropTypes.arrayOf(PropTypes.string).isRequired,
  onSelect: PropTypes.func.isRequired,
}

export const Step1GenericWhs = ({ levelSelections, onLevelSelect, onCourseSelect }) => {
  const levels = useSelector((state) => state?.misc?.data?.genericWhsLevels || [])
  const terminology = useSelector((state) => state?.misc?.data?.genericWhsTerminology || 'WHS')

  const courseLevel = levels[levels.length - 1]
  const parentLevels = levels.slice(0, -1)

  return (
    <div>
      <div className="courses-modal-dropdown-label add-margin-top-10">
        {window.I18n.t('generic_whs.courses.popup.import_course', { terminology })}
      </div>
      {parentLevels.map((level, index) => (
        <LevelSelect
          key={level}
          level={level}
          levelIndex={index}
          levelSelections={levelSelections}
          levels={levels}
          onSelect={(lvl, value, label) => {
            // Reset all child levels when a parent changes
            onLevelSelect(lvl, value, label, levels.slice(index + 1))
          }}
        />
      ))}
      {courseLevel && (
        <LevelSelect
          key={courseLevel}
          level={courseLevel}
          levelIndex={parentLevels.length}
          levelSelections={levelSelections}
          levels={levels}
          onSelect={(lvl, value, label) => {
            onLevelSelect(lvl, value, label, [])
            onCourseSelect(value, label)
          }}
        />
      )}
    </div>
  )
}

Step1GenericWhs.propTypes = {
  levelSelections: PropTypes.object.isRequired,
  onLevelSelect: PropTypes.func.isRequired,
  onCourseSelect: PropTypes.func.isRequired,
}
